import { constants } from '@/components'

// Reusable media query: https://emotion.sh/docs/media-queries#reusable-media-queries
export const mqMax = (size: keyof typeof constants.core.QUERIES): string =>
  `@media (max-width: ${constants.core.QUERIES[size]}px)`

export const mqMin = (size: keyof typeof constants.core.QUERIES): string =>
  `@media (min-width: ${constants.core.QUERIES[size]}px)`
